// extracted by mini-css-extract-plugin
export default {"yivi-web-form":"registration_verified_yivi-web-form__Bj4H-","yivi-web-content":"registration_verified_yivi-web-content__hKkWb","center":"registration_verified_center__0NVCB"};